import { useState } from 'react';
import { getCookie, setCookie } from '../utils/cookies';
import './CookieConsent.css';

const CONSENT_KEY = 'cookie_consent'; // plm_cookie_consent

/**
 * Cookie Consent Banner
 * Shows once — remembers the choice as a cookie itself (strictly necessary).
 * Accept  → preferences are saved in cookies.
 * Decline → preferences are not saved; app still works, just forgets settings.
 */
const CookieConsent = () => {
  const [visible, setVisible] = useState(() => getCookie(CONSENT_KEY) === null);

  if (!visible) return null;

  const handleAccept = () => {
    setCookie(CONSENT_KEY, 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    setCookie(CONSENT_KEY, 'declined');
    setVisible(false);
  };

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent-banner">
        <div className="cookie-consent-icon">🍪</div>
        <div className="cookie-consent-text">
          <strong>We use cookies and analytics to improve your experience</strong>
          <p>
            This app stores small cookies in your browser to remember your selected segment,
            timezone, category filter, and active tab. It also uses Adobe Analytics to collect
            anonymous usage data (pages visited, navigation patterns) so we can improve the
            experience. No personally identifiable information is collected.
          </p>
        </div>
        <div className="cookie-consent-actions">
          <button className="cookie-btn cookie-btn-accept" onClick={handleAccept}>
            Accept
          </button>
          <button className="cookie-btn cookie-btn-decline" onClick={handleDecline}>
            Decline
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
